import React from 'react';
import { H2 } from 'components/Heading';
import { ModalFooterButton } from 'components/Modal';
import { Step } from 'components/SteppedModal';
import useLinkedinAuthenticator, {
  UseLinkedInAuthenticatorConfig,
} from 'hooks/useLinkedinAuthenticator';
import { block } from '../utils';
import { LinkedinPostModalSteps } from './types';

export interface UseAccessDeniedStepConfig
  extends Pick<UseLinkedInAuthenticatorConfig, 'onError'> {
  onReviseAccess?: () => void;
}

export default function useAccessDeniedStep({
  onError,
  onReviseAccess,
}: UseAccessDeniedStepConfig): Step<LinkedinPostModalSteps> {
  const { authenticating, withAuthentication } = useLinkedinAuthenticator({
    force: true,
    onError,
  });

  return {
    id: 'access-denied',
    title: 'we need permission to post',
    fluidFooterButtons: true,
    component: (
      <H2 className={block('access-denied')}>
        We can’t post your video unless you allow us to manage and publish to
        your account.
      </H2>
    ),
    renderFooterButtons: ({ cancel, submit }) => [
      <ModalFooterButton {...cancel} key="cancel">
        cancel
      </ModalFooterButton>,

      <ModalFooterButton
        {...submit}
        key="submit"
        theme="submit"
        disabled={authenticating}
        onClick={withAuthentication(onReviseAccess)}
      >
        revise options
      </ModalFooterButton>,
    ],
  };
}
